<template>
  <section
    class="container max-w-5xl mx-auto flex flex-col flex-1 overflow-y-auto overflow-x-hidden transition-all box-border">
    <div class="container mx-auto mt-5 sm:mt-10 md:mt-20 mb-5 sm:mb-0 ">
      <Titre textePrincipal="Notre " texteAccentue="mission" :isSidebarOpen="isSidebarOpen" />
    </div>
    <!-- Section Notre Mission -->
    <div class="w-full mt-0 lg:mt-5 h-full mx-auto flex items-start justify-center">
      <div class="w-full h-full flex flex-col justify-center items-center sm:px-4 px-2">
        <!--  -->
        <div class="w-full mx-auto flex flex-col flex-wrap lg:flex-row items-center justify-center ">
          <div class="relative flex items-center justify-center w-full xl:w-1/3 h-auto">
            <!-- Main Img -->
            <img
              class="rounded-full relative object-cover sm:w-[20rem] sm:h-[20rem] w-[10rem] h-[10rem] outline sm:outline-offset-[.77em] outline-offset-[.27em] outline-green-500"
              src="/src/assets/images/bg_animaux_de_la_seconde_chance_1.webp" alt="Notre mission" />
          </div>
          <!--  -->
          <div
            class="w-full mx-auto mt-5 sm:mt-10 md:mt-0 xl:w-2/3 px-5 h-auto flex flex-col justify-center items-center rounded-xl font-serif">
            <p class="text-base sm:text-lg md:text-xl lg:text-2xl xl-text-3xl text-justify text-gray-500 my-5"><span
                class="font-bold text-secondaire font-cursive text-xl sm:text-2xl md:text-3xl lg:text-4xl">Notre</span><span
                class="text-primaire font-bold font-cursive text-xl sm:text-2xl md:text-3xl lg:text-4xl"> mission</span>
              est d'aider les animaux
              abandonnés de la région de Matane et ses environs. Bien que nous nous concentrions principalement sur les
              chats, nous apportons également notre soutien aux chiens dans le besoin.
            </p>
            <p class="text-base sm:text-lg md:text-xl lg:text-2xl xl-text-3xl text-justify text-gray-500">Nous
              sommes un petit groupe de
              passionnés, dévoués au bien-être de nos amis à quatre pattes. Nous recueillons ces animaux et leur offrons
              les soins vétérinaires nécessaires.
            </p>
          </div>
          <div class="max-w-7xl mx-auto lg:mb-16 p-4 h-auto flex flex-col justify-center items-center px-6 font-serif">
            <p class="text-base sm:text-lg md:text-xl lg:text-2xl xl-text-3xl text-justify sm:px-2 text-gray-500">
              De plus, nos familles d'accueil prennent soin d'eux le temps de leur
              trouver une famille aimante. Nous stérilisons également les animaux en âge de l'être grâce aux dons que
              nous recevons.
            </p>
            <p class="text-base sm:text-lg md:text-xl lg:text-2xl xl-text-3xl mt-5 text-justify sm:px-2 text-gray-500">
              <span class="font-bold">Les Animaux
                de la Seconde <span class="text-primaire">Chance</span>, </span>c'est plus de 3 000 chats qui ont trouvé
              une nouvelle famille. Lors de l'adoption d'un animal stérilisé, nous demandons une contribution financière
              pour nous aider à poursuivre notre mission de sauvetage.
            </p>

          </div>
        </div>
      </div>
    </div>
    <div class="w-full lg:max-w-7xl flex flex-wrap mx-auto pb-32 pt-16 border-t-2 border-primaire px-5">
      <h3
        class="pb-10 font-cursive text-center font-extrabold tracking-tight text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
        <span class="text-secondaire">Tarifs</span>&nbsp;<span class="text-primaire">d'adoption</span>&nbsp;🐱
      </h3>
      <div class="flex flex-wrap flex-col items-start font-serif">
        <ul
          class="mb-5 text-gray-500 text-base sm:text-lg md:text-xl lg:text-2xl xl-text-3xl md:max-w-full list-disc list-inside">
          <li>Moins de 5 mois, chaton vacciné et vermifugé : 110&nbsp;$</li>
          <li>5 mois et plus, mâle castré, vacciné et vermifugé : 140&nbsp;$</li>
          <li>5 mois et plus, femelle stérilisée, vaccinée et vermifugée : 170&nbsp;$</li>
        </ul>
        <p
          class="mb-5 text-base sm:text-lg md:text-xl lg:text-2xl xl-text-3xl text-gray-500 md:max-w-full text-justify">
          Ces montants nous
          permettent de couvrir les
          coûts des traitements et de la stérilisation. À noter que tous nos chats ont également reçu un vermifuge.</p>
        <p
          class="mb-5 text-base sm:text-lg md:text-xl lg:text-2xl xl-text-3xl text-gray-500 md:max-w-full text-justify">
          Tout le travail réalisé
          au sein des Animaux de
          la Seconde Chance est effectué bénévolement, et chaque centime est réinvesti dans les soins vétérinaires, la
          stérilisation et le bien-être de nos animaux.</p>
        <p class="text-base sm:text-lg md:text-xl lg:text-2xl xl-text-3xl text-gray-500 md:max-w-full">Merci de donner
          une seconde chance à ces
          précieux compagnons !
        </p>
      </div>

      <button
        class="mt-10 bg-action hover:bg-primaire shadow-lg text-white font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primaire focus:ring-opacity-50" 
        aria-label="Adopter un animal"
        title="Adopter un animal">
        <router-link to="/adoption" class="text-white" aria-label="Adopter un animal" title="Adopter un animal">Adopter un animal</router-link>
      </button>
    </div>
  </section>
</template>

<script>
import Titre from '../composants/Titre.vue';
import { isSidebarOpen } from '../store/storeSideBar';

export default {
  components: {
    Titre,
  },
  data() {
    return {
      isSidebarOpen, // Ajoutez isSidebarOpen ici
    };
  },
};

</script>



<style scoped>

</style>